import React from 'react'

import { IconProps } from './types'

const MenuVertical = ({ size, color, ...rest }: IconProps) => {
  return (
    <svg
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill={color}
      className="fill-[#181616] dark:fill-gray-100"
      {...rest}
    >
      <path d="M7.5 4.5V3.5H8.5V4.5H7.5Z" />
      <path d="M7.5 8.5V7.5H8.5V8.5H7.5Z" />
      <path d="M7.5 12.5L7.5 11.5H8.5V12.5H7.5Z" />
      <path d="M7.5 4.5V3.5H8.5V4.5H7.5Z" />
      <path d="M7.5 8.5V7.5H8.5V8.5H7.5Z" />
      <path d="M7.5 12.5L7.5 11.5H8.5V12.5H7.5Z" />
    </svg>
  )
}
MenuVertical.defaultProps = {
  size: 16,
  color: 'currentColor',
}

export default MenuVertical
